import React, { useEffect, useState } from 'react';
import { isNotEmpty, parseClasses, RGB_2_HEX } from '../../lib/ep.js';

const VideoEmbed = (props) => {
	const [ is_playing, setIsPlaying ] = useState(props?.autoplay ?? false);
	const [ is_playable, setIsPlayable ] = useState(true);
	const [ video_data, setVideoData ] = useState({});

	const display_place = props?.display_place ?? 'entries';	// multimedia / entries

	const page = props?.page ?? false;
	const promotion_id = props?.promotion_id ?? false;
	const playVideo = (e) => {
		e.stopPropagation();

		if(EP != undefined && page !== false && promotion_id !== false) {
			EP.shotPromoAction('videoplay', page, promotion_id);
		}

		setIsPlaying(true);
	};

	const parseVideo = () => {
		const url = props?.video_url ?? false;

		// - Supported YouTube URL formats:
		//   - http://www.youtube.com/watch?v=My2FRPA3Gf8
		//   - http://youtu.be/My2FRPA3Gf8
		//   - https://youtube.googleapis.com/v/My2FRPA3Gf8
		// - Supported Vimeo URL formats:
		//   - http://vimeo.com/25451551
		//   - http://player.vimeo.com/video/25451551
		// - Also supports relative URLs:
		//   - //player.vimeo.com/video/25451551
		if(!url) return;

		url.match(/(http:|https:|)\/\/(player.|www.)?(vimeo\.com|youtu(be\.com|\.be|be\.googleapis\.com))\/(video\/|videos\/|embed\/|watch\?v=|v\/)?([A-Za-z0-9._%-]*)(\&\S+)?/);

		const video_id = RegExp.$6;
		let hash = undefined;
		let platform = false;
		let video_url = false;
		let url_info = '';
		let thumbnail_url = false;
		if(RegExp.$3.indexOf('youtu') > -1) {
			platform = 'youtube';
			video_url = `https://www.youtube.com/embed/${video_id}`;
			thumbnail_url = props?.thumbnail_url ?? `https://i.ytimg.com/vi/${video_id}/maxresdefault.jpg`;
			url_info = '&showinfo=0&controls=' + (props?.controls ?? '0') + '&rel=0';

			const r = url.match(/t=(.*?)s\&?/);
			const e = url.match(/e=(.*)s/);

			if(r && r[1] != undefined) url_info += '&start='+r[1];	// start time parameter
			if(e && e[1] != undefined) url_info += '&end='+e[1];	// end time parameter
		} else if(RegExp.$3.indexOf('vimeo') > -1) {
			platform = 'vimeo';
			video_url = `https://player.vimeo.com/video/${video_id}`;
			if(props.hash != undefined) hash = props.hash;

			// 28-09-2021:
			// Segurament en un futur això caldrà canviar-ho, perquè ara genera URLs del pal https://i.vimeocdn.com/video/https://i.vimeocdn.com/video/1236697494
			// Ara s'ha hagut d'afegir la part "https://i.vimeocdn.com/video/" a la URL perquè funcioni, perque Vimeo retornava error
			if(isNotEmpty(props, 'thumbnail_url')) {
				setIsPlayable(true);
				thumbnail_url = `https://i.vimeocdn.com/video/${props.thumbnail_url}`;
			} else if(isNotEmpty(props, 'video_thumb')) {
				setIsPlayable(true);
				thumbnail_url = props.video_thumb;
			} else {
				setIsPlayable(false);
				thumbnail_url = `${window.cdn_url}img/video_processing_thumb.jpg`;
			}
		}

		setVideoData({
			id:video_id,
			platform,
			video_url,
			thumbnail_url,
			url_info,
			hash,
		});
	};

	useEffect(() => {
		parseVideo();
	}, []);

	let thumbnail_url = video_data.thumbnail_url;
	if(props.video_thumb) thumbnail_url = props.video_thumb;
	
	const hash = (video_data.hash != undefined) ? `&h=${video_data.hash}` : "";

	const main_color = RGB_2_HEX(props?.main_color ?? '2951CC', false);
	const layout = (props.layout != undefined && props.layout == 'public') ? 'emulate_public_play_btn' : '';

	var classname = props?.classname ?? 'original_color_item play_video_btn knk-play-round';
	const play_icon = parseClasses(classname, props._class, 'video_play_btn');

	const video_styles = (!is_playing) ? { backgroundImage:`url(${thumbnail_url})` } : null;

	return (
		<div class="gui_video_player video_preview regular_video" style={(display_place == 'entries') ? video_styles : null} onClick={(e) => playVideo(e)}>
			<div style={(display_place == 'multimedia') ? video_styles : null}>
				<img src={`${window.cdn_url}img/blank_16x9.png`} width="100%" alt="" />

				{(is_playable) && (
					(!is_playing) ? (
						<a class={`${play_icon} ${layout}`} />
					) : (
						<iframe
							src={`${video_data.video_url}?autoplay=1&html5=1${video_data.url_info}&color=${main_color}${hash}`}
							class="video_player"
							allowFullScreen
						/>
					)
				)}
			</div>
		</div>
	);
};
export default VideoEmbed;